/**
 * Extraction du code département depuis un code postal français.
 *
 * Règles La Poste :
 *   - 5 chiffres → 2 premiers = département (75001 → 75)
 *   - Corse : 20000-20190 → 2A, 20200-20620 → 2B
 *   - DOM-TOM : 9710X → 971, 9720X → 972, etc. (3 chiffres)
 *
 * Retourne null si le code postal est invalide.
 */
export function postalToDepartment(postalCode: string | null | undefined): string | null {
  if (!postalCode) return null;
  const code = postalCode.trim();
  if (!/^\d{5}$/.test(code)) return null;

  if (code.startsWith("97") || code.startsWith("98")) {
    return code.slice(0, 3);
  }

  if (code.startsWith("20")) {
    const n = Number(code);
    if (n >= 20000 && n <= 20190) return "2A";
    if (n >= 20200 && n <= 20620) return "2B";
    return "2A";
  }

  return code.slice(0, 2);
}
